import { CalendarInput } from "@/components/ui/forms/calendarInput"
import { InputContainer } from "@/components/ui/forms/inputContainer"
import { GenderInput } from "@/modules/auth/components/genderInput"
import { displayedFullDateFormat } from "@/modules/utils/dateUtils"
import { word } from "@modules/core/utils/i18n"
import { ProfileLabelVisibility } from "@modules/profile/myProfile/components/profileLabelVisibility"
import { type ProfileFormTabProps } from "@modules/profile/myProfile/profileFormikType"
import dayjs from "dayjs"
import { Text } from "@/components/ui/baseUi/text"

export function CrossfitInformationForm({ isFormFieldInValid, getFormErrorMessage, formik }: ProfileFormTabProps) {
  const handleSelectGender = (gender: "MALE" | "FEMALE") => {
    formik.setFieldValue("genderCategory", gender)
  }

  return (
    <div className="mt-6 flex grow flex-col justify-start gap-6 px-4">
      <Text fontStyle="TM" className="mb-4 self-center">
        {word("profile.form.crossfit.title")}
      </Text>

      {/* CrossFit starting date input */}
      <InputContainer>
        <ProfileLabelVisibility
          label={word("profile.form.crossfitStartDate.label")}
          name="crossfitStartDate"
          isInvalid={isFormFieldInValid("crossfitStartDate")}
          displayVisibleToggle
          visibility={formik.getFieldProps("crossfitStartDateVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue(
              "crossfitStartDateVisibility",
              !formik.getFieldProps("crossfitStartDateVisibility").value,
            )
          }
        />
        <CalendarInput
          name="crossfitStartDate"
          setFieldValue={formik.setFieldValue}
          getFieldProps={formik.getFieldProps}
          error={getFormErrorMessage("crossfitStartDate")}
          calendarProps={{
            minDate: dayjs().subtract(100, "year").toDate(),
            maxDate: dayjs().toDate(),
            dateFormat: displayedFullDateFormat,
            captionLayout: "dropdown",
          }}
          placeholder={word("profile.form.crossfitStartDate.label")}
        />
      </InputContainer>

      {/* Gender category input */}
      <InputContainer>
        <ProfileLabelVisibility
          label={word("profile.form.genderCategory.label")}
          name="genderCategory"
          isInvalid={isFormFieldInValid("genderCategory")}
          displayVisibleToggle
          visibility={formik.getFieldProps("genderCategoryVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("genderCategoryVisibility", !formik.getFieldProps("genderCategoryVisibility").value)
          }
        />
        <Text fontStyle="BS" style={{ whiteSpace: "pre-line", overflowWrap: "break-word" }}>
          {word("profile.form.genderCategory.description")}
        </Text>
      </InputContainer>

      <InputContainer>
        <GenderInput
          handleSelectGender={handleSelectGender}
          selectedGender={formik.getFieldProps("genderCategory").value}
        />
      </InputContainer>
    </div>
  )
}
